import React from 'react';
import useGoogleAnalytics from '../hooks/useGoogleAnalytics';
import { useTranslation } from 'react-i18next';

const ZendeskPrompts = () => {
  const { events } = useGoogleAnalytics();
  const { t } = useTranslation();

  const handleGetGuideClick = () => {
    // Send GA event for resource click or general navigation
    events.clickResource('App Builder Guide', 'https://buy.stripe.com/fZu5kDaQ8fxf9SVetW0oM02');
    window.open('https://buy.stripe.com/fZu5kDaQ8fxf9SVetW0oM02', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-16 w-full">
      <div className="bg-surface rounded-xl border border-line p-8 md:p-12 lg:p-16 text-center w-full">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
          {t('app_builder.title')}
        </h1>
        <h2 className="text-xl md:text-2xl font-medium text-white/50 mb-8">
          {t('app_builder.subtitle')}
        </h2>
        <p className="text-lg md:text-xl text-white/70 mb-12 text-left whitespace-pre-wrap leading-relaxed max-w-5xl mx-auto">
          {t('app_builder.description')}
        </p>
        <button 
          onClick={handleGetGuideClick}
          className="bg-cta hover:bg-cta-hover text-ink font-bold py-4 px-12 md:px-16 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:-translate-y-1 text-lg md:text-xl mb-16"
        >
          {t('app_builder.get_guide_button')}
        </button>

        <div className="w-full flex justify-center mb-12">
          <img 
            src="/appbuilder_zendesk.png" 
            alt="Zendesk App Builder Preview" 
            className="w-full h-auto rounded-lg shadow-lg border border-line"
          />
        </div>

        <p className="mt-8 text-white/50 text-sm md:text-base border-t border-line pt-8">
          {t('app_builder.contact_text')} <a href="mailto:contacto@easyappforz.com" className="text-accent-400 font-semibold hover:underline">contacto@easyappforz.com</a>
        </p>
      </div>
    </div>
  );
};

export default ZendeskPrompts;
